import React from 'react';
import { connect } from 'react-redux';

import CONSTANT from '../../constant';

class LocalFile extends React.Component {

    state = {
        isLocalFile: false,
    };

    constructor(props) {
        super(props);
    }

    componentDidMount() {
        const { project } = this.props;

        this.setState({
            isLocalFile: project.projectType === CONSTANT.PROJECT_TYPE.LOCAL
        });
    }

    render() {
        const { intlr } = this.props;
        const { isLocalFile } = this.state;

        return (
            <section className="header-cell user-menu-cell">
                <span className="editor-header-right">{isLocalFile && intlr.messages['MENU.FILE.LOCALFILE']}</span>
            </section>
        );
    }
}

export default connect(state => ({
    intlr: state.intlr,
    project: state.project
}))(LocalFile);